import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css"; // ✅ Import Bootstrap
import "bootstrap-icons/font/bootstrap-icons.css"; // ✅ Import Bootstrap Icons
import "../assets/css/main.css";
import "./Home.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "bootstrap/dist/js/bootstrap.bundle.min";
import Services from "./Services";
import Navbar from "./Nav";
import ChooseUs from "./ChooseUs";
import GetInTouch from "./GetInTouch";
import OurServices from "./OurServices";
import Testimonials from "./Testimonials";
import RecentPosts from "./RecentPosts";
import Footer from "./Footer";
import Header from "./Header";
import Objectives from "./Objectives";
import AOS from "aos";
import "aos/dist/aos.css";
import WhoWeAreImage from "../assets/img/Whowearesectionimage.jpg";
import OurCollobrationImage from "../assets/img/Ourcollaborationspageimage.jpg";
import OurCollobrationImage1 from "../assets/img/OurCollobrationImage1.png";
import OurCollobrationImage2 from "../assets/img/OurCollobrationImage2.png";
import OurCollobrationImage3 from "../assets/img/OurCollobrationImage3.png";

const Home = () => {
  useEffect(() => {
    AOS.init({
      duration: 800, // Animation duration
      offset: 100, // Offset before animation starts
      easing: "ease-in-out",
      once: true, // Animation occurs only once
    });
  }, []);

  return (
    <>
      <div className="index-page">
        {/* <div><Navbar/></div> */}
        <main className="main">
          <div>
            {/* <Header /> */} <OurServices />
          </div>

          <div className="section-separator" data-aos="fade-up">
            <h2 className="separator-title" style={{ color: "#d4561a" }}>
              About Us
            </h2>
            <div className="separator-line"></div>
          </div>
          <section
            id="collaboration"
            className="collaboration section"
            style={{ backgroundColor: "#d4561a" }}
          >
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-5 ml-auto" data-aos="fade-right">
                  <h3 className="content-subtitle" style={{ color: "black" }}>
                    Who We Are?
                  </h3>
                  <p style={{ color: "black", marginTop: "20px" }}>
                    The Indo Pulses Development Association (IPDA) is pioneering
                    Commodity Stewardship Council (CSC) dedicated to
                    transforming the country’s pulses sector. Established under
                    the Hon’ble Balasaheb Thackeray Agribusiness and Rural
                    Transformation (SMART) Project. IPDA is spearheaded by the
                    Project Implementation Unit (PIU)- Village and Social
                    Transformation Foundation (VSTF) with strategic support from
                    the Government of Maharashtra, the World Bank, and Grant
                    Thornton Bharat LLP as the Technical Service Provider (TSP).
                    IPDA functions as a collaborative, multi-stakeholder
                    platform uniting farmers, Farmer Producer Organizations
                    (FPOs), processors, industry players, policymakers,
                    researchers, and development agencies to drive systemic
                    improvements across the pulses value chain. From boosting
                    productivity and promoting innovation to shaping policies
                    and enhancing market access, IPDA aims to unlock the full
                    potential of India’s pulses sector.
                  </p>
                </div>
                <div className="col-lg-6 position-relative" data-aos="zoom-in">
                  <img
                    src={WhoWeAreImage}
                    alt="Collaboration"
                    className="img-fluid img-overlap rounded"
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "10px",
                    }}
                  />
                </div>
              </div>
            </div>
          </section>

          <section className="bg-white py-12 px-4" data-aos="fade-up">
            {/* Section Header */}
            <div className="text-center">
              <h2
                className="text-3xl md:text-4xl font-extrabold"
                style={{ color: "#d4561a" }}
              >
                Our Collaborations
              </h2>
              <div className="separator-line mx-auto mt-2 mb-4 h-1 w-16 bg-yellow-400 rounded-full"></div>
            </div>

            {/* Shared Content */}
            <div className="max-w-5xl mx-auto mt-6">
              <p className="text-center text-gray-700 text-base md:text-lg leading-relaxed mb-10 px-4 md:px-6">
                At <span className="font-semibold text-gray-900">IPDA</span>,
                collaboration is at the heart of transformation. We are proud to
                partner with globally recognized institutions—
                <strong>ICAR-IIPR</strong>,<strong>ICRISAT</strong>, and{" "}
                <strong>GFI India</strong>. These strategic alliances bring
                together world-class research, innovation, and technical
                expertise to accelerate breakthroughs in the pulses sector. From
                advancing climate-resilient seed systems and sustainable
                agronomic practices to pioneering plant-based protein solutions,
                these partnerships strengthen IPDA’s mission to build a
                nutrition-smart, future-ready, and globally competitive pulses
                ecosystem.
              </p>
            </div>
            {/* Company Logos */}
            <div className="flex flex-wrap justify-center items-center gap-8">
              <img
                src={OurCollobrationImage1}
                alt="ICAR-IIPR"
                className="h-12 w-auto grayscale hover:grayscale-0 transition duration-300 ease-in-out"
              />
              <img
                src={OurCollobrationImage2}
                alt="ICRISAT"
                className="h-12 w-auto grayscale hover:grayscale-0 transition duration-300 ease-in-out"
              />
              <img
                src={OurCollobrationImage3}
                alt="GFI India"
                className="h-12 w-auto grayscale hover:grayscale-0 transition duration-300 ease-in-out"
              />
            </div>
          </section>

          {/* <section
            id="collaboration"
            className="collaboration section py-5"
            style={{ backgroundColor: "white" }}
          >
            <div className="container">
              <div className="row align-items-center gap-5 px-3"> */}
          {/* Image on the Left */}
          {/* <div className="col-lg-5" data-aos="zoom-in">
                  <img
                    src={OurCollobrationImage}
                    alt="Collaboration"
                    className="img-fluid rounded shadow"
                    style={{
                      width: "100%",
                      maxHeight: "450px",
                      objectFit: "cover",
                    }}
                  />
                </div> */}

          {/* Content on the Right */}
          {/* <div
                  className="col-lg-6 mt-4 mt-lg-0 my-4"
                  data-aos="fade-left"
                >
                  <p className="text-dark mt-3 fw-bold">
                    At IPDA, collaboration is at the heart of transformation. We
                    are proud to partner with globally recognized
                    institutions—ICAR-Indian Institute of Pulses Research
                    (ICAR-IIPR), International Crops Research Institute for the
                    Semi-Arid Tropics (ICRISAT), and the Good Food Institute
                    India (GFI India). These strategic alliances bring together
                    world-class research, innovation, and technical expertise to
                    accelerate breakthroughs in the pulses sector. From
                    advancing climate-resilient seed systems and sustainable
                    agronomic practices to driving next-generation plant-based
                    protein solutions, these partnerships strengthen IPDA’s
                    mission to build a future-ready, nutrition-smart, and
                    globally competitive pulses ecosystem.
                  </p>
                  <p className="text-dark fw-bold" data-aos="fade-up">
                    Our mission is to enhance India’s pulses sector through
                    collaboration, capacity building, and market-driven
                    solutions that empower farmers and promote sustainable
                    growth.
                  </p>
                </div> */}
          {/* </div>
            </div>
          </section> */}

          {/* 🔹 Stylish Separator for Purpose & Objectives Section */}
          {/* <div className="section-separator" data-aos="fade-up">
            <h2 className="separator-title" style={{ color: "#d4561a" }}>
              Purpose and Objectives
            </h2>
            <div className="separator-line"></div>
          </div> */}

          <div>
            <Services />
          </div>
          <div>
            <Objectives />
          </div>

          {/* 🔹 Another separator for "Why Choose Us" */}
          <div className="section-separator" data-aos="fade-up">
            <h2 className="separator-title" style={{ color: "#d4561a" }}>
              Why Choose Us?
            </h2>
            <div className="separator-line"></div>
          </div>

          <div>
            <ChooseUs />
          </div>

          <div>{/* <GetInTouch /> */}</div>
          {/* <div>
            <OurServices />
          </div> */}

          {/* 🔹 Separator for Recent Posts */}
          {/* <div className="section-separator" data-aos="fade-up">
            <h2 className="separator-title" style={{ color: "#d4561a" }}>
              Recent Posts
            </h2>
            <div className="separator-line"></div>
          </div> */}

          {/* <div>
            <RecentPosts />
          </div> */}
        </main>
        <div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Home;
